import { HttpContextToken } from '@angular/common/http';

/**
 * HTTP Context Token to skip the global full-screen loading indicator for a request.
 *
 * Uses `HttpContext` (not a real header) so it never crosses the network and can't trigger a CORS preflight — unlike a
 * custom header, which requires the target API's CORS policy to explicitly allow it.
 *
 * NOTE: when this app is hosted as a Module Federation remote inside `web.shell` (`withRequestsMadeViaParent()`), the
 * request is ultimately dispatched through the SHELL's own HttpClient/interceptor chain, which resolves its own
 * (separately bundled) copy of this token. `HttpContext` lookups are by object reference, so a value set against the
 * remote's token instance is invisible to the shell's — always pair this context token with the `SKIP_LOADING_HEADER`
 * below, which survives that boundary since headers are plain strings.
 *
 * @example
 *   ```typescript
 *   this.http.get('/api/data', {
 *     context: new HttpContext().set(SKIP_LOADING_INDICATOR, true),
 *     headers: new HttpHeaders({ [SKIP_LOADING_HEADER]: 'true' })
 *   });
 *   ```;
 */
export const SKIP_LOADING_INDICATOR = new HttpContextToken<boolean>(() => false);

/**
 * HTTP header name recognized by `loadingInterceptor` (harmony) to skip the global loader. Preferred over
 * `SKIP_LOADING_INDICATOR` when a request may cross a Module Federation remote/host boundary, since header values are
 * plain strings and survive that boundary.
 */
export const SKIP_LOADING_HEADER = 'X-Skip-Loading';
